
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'


export default {
components: {
XButton,
XHeader
},
name: 'noAccess',
data () {
return {

}
},
created() {

},
methods:{

}
}



// WEBPACK FOOTER //
// ./src/pages/notaxes.vue